import React, { ReactElement } from 'react';
import DOMPurify from 'dompurify';
import { Col, Heading, Row } from 'idsk-react-components';
import './kontakty.scss';
import { Kontakt } from '../../model/Kontakt';

interface Props {
  data: Kontakt[] | null | undefined
}

const Kontakty = (
  { data }
    : Props,
): ReactElement => (
  <div className="kontakty">
    <Heading size="xl" className="kontakty-main__heading">Kontakt</Heading>
    {data && (
      <Row className="kontakty-main__row">
        {data.map(sekcia => (
          <Col className="kontakty-main__col" key={`kontaktColKey-${sekcia.id}`} width="one-half">
            {sekcia.nadpis && (
              <Heading size="m">{sekcia.nadpis}</Heading>
            )}
            <>
              {/* eslint-disable-next-line react/no-danger */}
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(sekcia.text) }} />
            </>
          </Col>
        ))}
      </Row>
    )}
  </div>

);

export default Kontakty;
